import React from 'react'

import {
  TagIcon,
  DeleteIcon,
  HelpIcon,
  LinkIcon,
  PlanetIcon,
} from 'components/Utils/Icons'

import { LayoutWrapper, LayoutSection, LayoutSeparator } from './Layout'

type SettingsOrganizationsInformationsLayoutBodyProps = {
  organizationIsFree: boolean
  canManage: boolean
  isOwner: boolean
  Informations: React.ComponentType<{}>
  Sharing: React.ComponentType<{}>
  Join: React.ComponentType<{}>
  Backup: React.ComponentType<{}>
  DeleteTeam: React.ComponentType<{}>
}

export function SettingsOrganizationsInformationsLayoutBody({
  // Data
  organizationIsFree,
  canManage,
  isOwner,
  // Section components
  Sharing,
  Informations,
  Join,
  Backup,
  DeleteTeam,
}: SettingsOrganizationsInformationsLayoutBodyProps) {
  const canAccess = organizationIsFree || canManage

  if (!canAccess) {
    return (
      <div>You must be owner or admin of your team to access the settings</div>
    )
  }

  return (
    <LayoutWrapper>
      <LayoutSection
        Icon={TagIcon}
        title="Name and logo"
        subtitle="Manage your team name, URL and logo."
      >
        <Informations />
      </LayoutSection>

      <LayoutSeparator />
      <LayoutSection
        Icon={PlanetIcon}
        title="Authorized domains"
        subtitle="Manage which email domains can auto-join your team."
      >
        <Join />
      </LayoutSection>

      <LayoutSeparator />
      <LayoutSection
        Icon={LinkIcon}
        title="Sharing"
        subtitle="Control who can invite to your Slite or share its content."
      >
        <Sharing />
      </LayoutSection>

      <LayoutSeparator />
      <LayoutSection
        Icon={HelpIcon}
        title="Back up"
        subtitle="Download a copy of your workspace's content"
      >
        <Backup />
      </LayoutSection>

      {isOwner && (
        <React.Fragment>
          <LayoutSeparator />
          <LayoutSection
            Icon={DeleteIcon}
            title="Team deletion"
            subtitle="Once you delete this team we will remove all associated data. There is no turning back."
          >
            <DeleteTeam />
          </LayoutSection>
        </React.Fragment>
      )}
    </LayoutWrapper>
  )
}
